<hw-page-header class="page-header sticky" header="mdm.obs-def-02.header">
  <div class="content float-right">
    <button nz-button nzType="primary" (click)="save()" *ngIf="hasEditPrivileges">
      {{ 'core.btn.save' | translate }}
    </button>
    <hw-dropdown>
      <a *hwDropdownItemIf="!!definition?.id" (click)="exportObservationDefinition()">
        <i class="dropdown-menu-icon" nz-icon nzType="download" nzTheme="outline"></i>
        {{ 'mdm.obs-def-02.export' | translate }}
      </a>
    </hw-dropdown>
  </div>
</hw-page-header>

<nz-content class="page-content" *ngIf="definition">
  <div class="page-content__container container">
    <div nz-col nzSpan="24">
      <form #form="ngForm">
        <hw-form-row>
          <div *hw-form-col>
            <hw-form-item name="category" label="mdm.obs-def-02.form.category" required>
              <hw-term-codesystem-concept-select
                [(ngModel)]="definition.category"
                name="category"
                codesystem="observation-category"
                valueType="codeName"
                required></hw-term-codesystem-concept-select>
            </hw-form-item>
            <hw-form-item name="code" label="mdm.obs-def-02.form.code" required>
              <input nz-input name="code" [(ngModel)]="definition.code" required />
            </hw-form-item>
            <hw-form-item name="names" label="mdm.obs-def-02.form.names" required>
              <hw-multilang-input name="names" [(ngModel)]="definition.names" required></hw-multilang-input>
            </hw-form-item>
            <ng-container>
              <hw-form-item name="lower" label="mdm.obs-def-02.form.from" required>
                <hw-date-picker name="lower" [(ngModel)]="definition.period.lower" required></hw-date-picker>
              </hw-form-item>
              <hw-form-item name="upper" label="mdm.obs-def-02.form.to">
                <hw-date-picker name="upper" [(ngModel)]="definition.period.upper"></hw-date-picker>
              </hw-form-item>
            </ng-container>
            <hw-form-item name="group" label="mdm.obs-def-02.groups">
              <hw-select name="group" [(ngModel)]="definition.groups" [multiple]="true" compareWith="id">
                <hw-option *ngFor="let gr of allGroups" [label]="gr.names | localName" [value]="gr"></hw-option>
              </hw-select>
            </hw-form-item>
            <hw-form-item name="bodySite" label="mdm.obs-def-02.form.body-site">
              <hw-snomed-expression-input
                name="bodySite"
                [(ngModel)]="definition.bodySite"></hw-snomed-expression-input>
            </hw-form-item>
            <hw-form-item name="descriptionAllowed" label="mdm.obs-def-02.form.description-allowed">
              <label nz-checkbox [(ngModel)]="definition.properties.descriptionAllowed" name="descriptionAllowed">
              </label>
            </hw-form-item>
            <hw-form-item name="crosstabDisplayed" label="mdm.obs-def-02.form.crosstab-displayed">
              <label nz-checkbox [(ngModel)]="definition.properties.crosstabDisplayed" name="crosstabDisplayed">
              </label>
            </hw-form-item>
          </div>
        </hw-form-row>

        <div style="margin-top: 20px"></div>
        <hw-observation-definition-references-table
          #referencesTableComponent
          [definition]="definition"
          [editMode]="hasEditPrivileges"></hw-observation-definition-references-table>
        <nz-divider [nzText]="'mdm.obs-def-02.form.data-type-settings' | translate" nzOrientation="left"></nz-divider>
        <hw-observation-definition-data-settings
          #dataSettings
          [definition]="definition"
          [editMode]="hasEditPrivileges"></hw-observation-definition-data-settings>
      </form>

      <div style="margin-top: 20px"></div>
      <hw-observation-definition-intervals-table
        #intervalTableComponent
        [definition]="definition"
        [editMode]="hasEditPrivileges"></hw-observation-definition-intervals-table>
      <hw-observation-definition-identifiers-table
        #identifiersTableComponent
        [definition]="definition"
        [editMode]="hasEditPrivileges"></hw-observation-definition-identifiers-table>
      <hw-observation-definition-targets-table
        #targetsTableComponent
        [definition]="definition"
        [editMode]="hasEditPrivileges"></hw-observation-definition-targets-table>
    </div>
  </div>
</nz-content>
